import React from 'react';
import { Box } from '@mui/material';
import { KpiStrip } from './KpiStrip';
import { PipelineFlow } from './PipelineFlow';
import { AttentionList } from './AttentionList';
import { TopClients } from './TopClients';
import { TrendChart } from './TrendChart';
import { SectionCard } from './SectionCard';
import { EstadoBolsa } from '../state/bolsaMachine';
import { BolsaCentro, MetricasCentro } from '../types';

interface ResumenTabProps {
  metricas: MetricasCentro | null;
  bolsasAbiertas: BolsaCentro[];
  cotizaciones: BolsaCentro[];
  onAbrirDrawer: (id: string) => void;
  onVerBolsasAbiertas: () => void;
  onFiltrar: (estado: EstadoBolsa | 'TODAS') => void;
  onVerDetalle: (id: string) => void;
}

export const ResumenTab: React.FC<ResumenTabProps> = ({
  metricas,
  bolsasAbiertas,
  cotizaciones,
  onAbrirDrawer,
  onVerBolsasAbiertas,
  onFiltrar,
  onVerDetalle,
}) => {
  return (
    <Box data-testid="tab-panel-resumen">
      <KpiStrip metricas={metricas} cotizaciones={cotizaciones} />
      <SectionCard title="Flujo del pipeline">
        <PipelineFlow
          bolsasAbiertas={bolsasAbiertas}
          cotizaciones={cotizaciones}
          onFiltrar={onFiltrar}
          onVerBolsasAbiertas={onVerBolsasAbiertas}
        />
      </SectionCard>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: '20px', alignItems: 'start' }}>
        <SectionCard title="Requiere atención">
          <AttentionList cotizaciones={cotizaciones} onAbrirDrawer={onAbrirDrawer} onVerDetalle={onVerDetalle} />
        </SectionCard>
        <SectionCard title="Top clientes">
          <TopClients cotizaciones={cotizaciones} />
        </SectionCard>
      </Box>

      <SectionCard title="Cotizado vs. ganado — últimos 6 meses">
        <TrendChart cotizaciones={cotizaciones} />
      </SectionCard>
    </Box>
  );
};
